import { useEffect, useRef, useState } from "react";
import { Checkbox, ComboBox, DefaultButton, Dialog, DialogType, IComboBoxOption, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import styles from '../styles/pokemon.module.scss';
import { TConfig, TSet } from "../constants/types";
import { ObjectArraysEqual } from "../services/Globals";
import EditTags from "./editTagsComponent";
import EditProps from "./editPropsComponent";

export interface ISetManagerV2Props {
    Sets : TSet[];
    site: string;
    token: string;
    username: string;
    apiUrl: string;
    setError: Function;
    setMessage: Function;
}

type TTree = {
    Children: TTree[];
    Value: TSet;
    Logo?: File;
    Banner?: File;
    BannerInCarousel: boolean;
} 

const SetManagerV2 : React.FunctionComponent<ISetManagerV2Props> = (props : ISetManagerV2Props) => {
    const [NewSetName, setNewSetName] = useState<string>();
    const [SetsCBOptions, setSetsCBOptions] = useState<IComboBoxOption[]>([]);
    const [NewSetImgFile, setNewSetImgFile] = useState<File>();
    const [NewSetParentSet, setNewSetParentSet ] = useState<string>();
    const [SetTree, setSetTree] = useState<TTree[]>([]);
    const [OrgSetTree, setOrgSetTree] = useState<TTree[]>([]);
    const [showSaveConfirm, setshowSaveConfirm] = useState<boolean>(false);

    const [SelectedSet, setSelectedSet] = useState<TTree>();
    const [SelectedSetNewName, setSelectedSetNewName] = useState<string>();
    const [SelectedSetNewParent, setSelectedSetNewParent] = useState<string>();
    const [SelectedSetNewImg, setSelectedSetNewImg] = useState<File>();
    const [SelectedSetBannerNewImg, setSelectedSetBannerNewImg] = useState<File>();

    const [bannerInCarousel, setBannerInCarousel] = useState<boolean>(false);

    const newSetLogoInputRef = useRef<HTMLInputElement>(null);
    const logoInputRef = useRef<HTMLInputElement>(null);
    const bannerInputRef = useRef<HTMLInputElement>(null);

    const [mainCarouselSets, setMainCarouselSets] = useState<string>();
    const [reload, setreload] = useState<number>();

    useEffect(() => {
        fetch(`${props.apiUrl}/GetConfig?username=${props.username}&token=${props.token}&site=${props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data: TConfig[]) => {
            let mcs: string = "";
            data.forEach((d) => {
                switch (d.name) {
                    case "MainCarouselSets":
                        mcs = d.value;
                        setMainCarouselSets(d.value);
                        break;
                    default:
                        break;
                }
            });

            if (props.Sets.length) {
                let setCBOptions : IComboBoxOption[] = [];
                
                setCBOptions.push({
                    key: "",
                    text: ""
                });
                
                props.Sets.forEach(set => {
                    setCBOptions.push({
                        key: set.name,
                        text: set.name
                    });
                });
                setSetsCBOptions(setCBOptions);

                let tree : TTree[] = [];
                let orgtree : TTree[] = [];
                props.Sets.forEach(set => {
                    if (!set.parentid) {
                        tree.push({Children:[], Value: set, BannerInCarousel: inCarousel(set, mcs)});
                        orgtree.push({Children:[], Value: set, BannerInCarousel: inCarousel(set, mcs)});
                    }
                });
                tree.forEach(tr => {
                    let children : TTree[] = [];
                    props.Sets.filter(set => set.parentid === (tr.Value as TSet).id).forEach(sc => {
                        children.push({Children:[], Value: sc, BannerInCarousel: inCarousel(sc, mcs)});
                    });
                    tr.Children = children ? children : [];
                });
                orgtree.forEach(tr => {
                    let children : TTree[] = [];
                    props.Sets.filter(set => set.parentid === (tr.Value as TSet).id).forEach(sc => {
                        children.push({Children:[], Value: sc, BannerInCarousel: inCarousel(sc, mcs)});
                    });
                    tr.Children = children ? children : [];
                });
                setOrgSetTree(orgtree);
                setSetTree(tree);
            }
        }).catch(err => {
            console.log(err);
        });       
    },[props.Sets, reload]);

    useEffect(() => {
        if (mainCarouselSets && SelectedSet) {
            let buff = mainCarouselSets.split(',');
            if (buff.indexOf(SelectedSet.Value.id.toString()) === -1) {
                setBannerInCarousel(false);
            } else {
                setBannerInCarousel(true);
            }
        }
    },[SelectedSet]);

    function addSet(save:boolean = false) {
        let buf = SetTree;
        if (NewSetParentSet) {
            let tr = buf.filter(b => b.Value.name === NewSetParentSet);
            tr[0].Children.push({Children:[], Value: {
                name: NewSetName, 
                parentid: tr[0].Value.id,
                id: -Date.now(),
                accr: "",
                expansion: "",
                expansionAccr: "",
                size: 0,
                extrasize: 0,
                scardnumber: "",
                scost: "",
                cost: 0,
                imageNames: "",
                defaultlwhw: '300,300,80,200',
                defaulttags: '',
                cardcount: 0
            }, Logo: NewSetImgFile, 
               Banner: NewSetImgFile, 
               BannerInCarousel: bannerInCarousel})
        } else {
            buf.push({Children: [], Value: {
                name: NewSetName,
                id: -Date.now(),
                accr: "",
                expansion: "",
                expansionAccr: "",
                size: 0,
                extrasize: 0,
                parentid: 0,
                scardnumber: "",
                scost: "",
                cost: 0,
                imageNames: "",
                defaultlwhw: '300,300,80,200',
                defaulttags: '',
                cardcount: 0
            }, Logo: NewSetImgFile, 
               Banner: NewSetImgFile, 
               BannerInCarousel: bannerInCarousel});
        }

        let setCBOptions = SetsCBOptions;
        setCBOptions.push({
            key: NewSetName,
            text: NewSetName
        });
        
        setSetsCBOptions(setCBOptions);
        setSetTree(buf);
        setNewSetParentSet("");
        setNewSetImgFile(undefined);
        setNewSetName("");

        if (save) {
            saveInSite();
        }
    }

    function canAddSet() : boolean {
        if (NewSetName?.length > 0) {
            return true;
        }
        return false;
    }

    function inCarousel(set: TSet, mcs: string = mainCarouselSets) : boolean {
        return mcs?.split(',').indexOf(set.id.toString()) !== -1;
    }

    function canChangeSet() : boolean {
        if (SelectedSetNewName && SelectedSet.Value.name !== SelectedSetNewName) {
            return true;
        }
        if (SelectedSetNewImg) {
            return true;
        }
        if (SelectedSetBannerNewImg) {
            return true;
        }
        if (SelectedSetNewParent || (SelectedSetNewParent === "" && SelectedSet.Value.parentid)) {
            return true;
        }
        if (SelectedSet && bannerInCarousel !== inCarousel(SelectedSet.Value)) {
            return true;
        }
        return false;
    }

    function SetSelectedSet(t : TTree) {
        setSelectedSetNewName(undefined);
        setSelectedSetNewParent(undefined);
        setSelectedSetNewImg(undefined);
        setSelectedSetBannerNewImg(undefined);
        setSelectedSetNewName(undefined);
        setSelectedSet(t);
    }

    function updateSet(save : boolean = false) {
        let updatedSet : TTree = {
            Children: [],
            BannerInCarousel: bannerInCarousel,
            Value: {
                id: SelectedSet.Value.id,
                name: SelectedSet.Value.name,
                accr: SelectedSet.Value.accr,
                expansion: SelectedSet.Value.expansion,
                expansionAccr: SelectedSet.Value.expansionAccr,
                size: SelectedSet.Value.size,
                extrasize: SelectedSet.Value.extrasize,
                parentid: SelectedSet.Value.parentid,
                scardnumber: SelectedSet.Value.scardnumber,
                scost: SelectedSet.Value.scost,
                cost: SelectedSet.Value.cost,
                imageNames: SelectedSet.Value.imageNames,
                cardcount: SelectedSet.Value.cardcount,
                defaultlwhw: SelectedSet.Value.defaultlwhw,
                defaulttags: SelectedSet.Value.defaulttags
            }
        };

        if (SelectedSetNewName?.length > 0) {
            updatedSet.Value.name = SelectedSetNewName;
        } else {
            updatedSet.Value.name = SelectedSet.Value.name;
        }
        if (SelectedSetNewParent?.length > 0) {
            updatedSet.Value.parentid = SetTree.filter(st => st.Value.name === SelectedSetNewParent)[0].Value.id;
        } else if (SelectedSetNewParent === "") {
            updatedSet.Value.parentid = undefined;
        } else {
            updatedSet.Value.parentid = SelectedSet.Value.parentid;
        }
        if (SelectedSetNewImg) {
            updatedSet.Logo = SelectedSetNewImg;
        } else {
            updatedSet.Logo = SelectedSet.Logo;
        }
        if (SelectedSetBannerNewImg) {
            updatedSet.Banner = SelectedSetBannerNewImg;
        } else {
            updatedSet.Banner = SelectedSet.Banner;
        }

        let newSetTree : TTree[] = [];
        if (updatedSet.Value.parentid) {
            SetTree.forEach(s => {
                if (updatedSet.Value.parentid === s.Value.id) {
                    let tempSet : TTree = {Children: [], Value: s.Value, Logo: s.Logo, Banner: s.Banner, BannerInCarousel: s.BannerInCarousel};
                    
                    let updatedChild : boolean = false;
                    s.Children.forEach(c => {
                        if (c.Value.id === updatedSet.Value.id) {
                            updatedChild = true;
                            tempSet.Children.push(updatedSet);
                        } else {
                            tempSet.Children.push(c);
                        }
                    });
                    if (!updatedChild) {
                        tempSet.Children.push(updatedSet);
                    }

                    newSetTree.push(tempSet);
                } else {
                    if (s.Value.id !== updatedSet.Value.id) {
                        let tempSet : TTree = {Children: [], Value: s.Value, Logo: s.Logo, Banner: s.Banner, BannerInCarousel: s.BannerInCarousel};

                        s.Children.forEach(c => {
                            if (c.Value.id !== updatedSet.Value.id) {
                                tempSet.Children.push(c);
                            }
                        });

                        newSetTree.push(tempSet);
                    }
                }
            });
        } else {
            let added : boolean = false;
            SetTree.forEach(s => {
                if (s.Value.id === updatedSet.Value.id) {
                    added = true;
                    newSetTree.push(updatedSet);
                } else {
                    let tempSet : TTree = {Children: [], Value: s.Value, Logo: s.Logo, Banner: s.Banner, BannerInCarousel: s.BannerInCarousel};

                    s.Children.forEach((c)=> {
                        if (c.Value.id === updatedSet.Value.id) {
                            if (c.Value.parentid === updatedSet.Value.parentid) {
                                tempSet.Children.push(updatedSet);
                                added = true;
                            } 
                        }
                    });

                    newSetTree.push(tempSet);
                }
            });
            if (added === false) {
                newSetTree.push(updatedSet);
            }
        }

        newSetTree.sort((a,b) => a.Value.name < b.Value.name ? -1 : 1);

        setSelectedSet(undefined);
        setSetTree(newSetTree);
        setNewSetImgFile(undefined);
        setNewSetName(undefined);
        setNewSetParentSet(undefined);

        if (save) {
            saveInSite(newSetTree);
        }
    }

    function saveInSite(newSetTree : TTree[] = SetTree) {
        let promises = [];
        let newMainCarouselSets = "";
        newSetTree.forEach(st => {
            if (st.BannerInCarousel) {
                newMainCarouselSets += (newMainCarouselSets === "" ? "" : ",") + st.Value.id;
            }
            if (st.Value.id < 0) {
                callBackendUpdateSet(st).then(newID => {
                    if (newID > 0) {
                        st.Children.forEach(c => {
                            if (c.BannerInCarousel) {
                                newMainCarouselSets += (newMainCarouselSets === "" ? "" : ",") + c.Value.id;
                            }
                            c.Value.parentid = newID;
                            promises.push(callBackendUpdateSet(c));
                        });
                    } else {
                        props.setError("Er is iets mis gegaan tijdens de opslag van de sets.");            
                    }
                }).catch(() => {
                    props.setError("Er is iets mis gegaan tijdens de opslag van de sets.");        
                });
            } else {
                promises.push(callBackendUpdateSet(st));
                st.Children.forEach(c => {
                    if (c.BannerInCarousel) {
                        newMainCarouselSets += (newMainCarouselSets === "" ? "" : ",") + c.Value.id;
                    }
                    promises.push(callBackendUpdateSet(c));
                });
            }
        });

        Promise.all(promises).then((result) => {
            if (newMainCarouselSets != mainCarouselSets) {
                fetch(`${props.apiUrl}/SetConfig?username=${props.username}&token=${props.token}&site=${props.site}&name=MainCarouselSets&value=${newMainCarouselSets}`, {
                    method: "Get", 
                    mode: 'cors',
                }).then((response) => response.json()).then((data) => data).then((success:boolean) => {
                    if (success) {
                        props.setMessage("De sets zijn successvol opgeslagen.");
                        setreload(Date.now());
                    } else {
                        props.setError("Opslag configuratie gefaald.");
                    }
                }).catch((ex) => {
                    props.setError(ex);
                });
            } else {
                props.setMessage("De sets zijn successvol opgeslagen.");
            }
        }).catch((err) => {
            console.log(err);
            props.setError("Er is iets mis gegaan tijdens de opslag van de sets. "+err);
        });
    }

    function callBackendUpdateSet(st : TTree) : Promise<number> {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            if (st.Logo) {
                const nameparts = st.Logo.name.split('.');        
                const extention = nameparts[nameparts.length - 1];
                formData.append(st.Value.id + "." + extention, st.Logo);
            }
            if (st.Banner) {
                const nameparts = st.Banner.name.split('.');        
                const extention = nameparts[nameparts.length - 1];
                formData.append("logo." + extention, st.Banner);
            }

            formData.append("id", st.Value.id.toString());
            formData.append("name", st.Value.name);
            formData.append("parentid", st.Value.parentid ? st.Value.parentid.toString() : '0');
            formData.append("token",props.token);
            formData.append("username",props.username);
            formData.append("site",props.site);
            formData.append("defaultlwhw",st.Value.defaultlwhw);
            formData.append("defaulttags",st.Value.defaulttags);
            fetch(`${props.apiUrl}/UpdateSet`, {
                method: "Put",
                mode: "cors",
                referrerPolicy: "origin-when-cross-origin",
                body: formData
                }).then((response) => response.json()).then((data: number) => {
                    resolve(data);
                }).catch(err => {
                    reject(-1);
            });
        });
    }

    return (
        <Stack horizontal style={{marginLeft:0, display: window.innerWidth > 950 ? "flex":"block"}}>
            <Dialog
                hidden={!showSaveConfirm}
                dialogContentProps={{ type: DialogType.normal }}
                onDismiss={() => { setshowSaveConfirm(false); }}
                modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
            >
                <Stack horizontalAlign='center' style={{backgroundColor:"white",padding:20}}>
                    <Label>Weet u zeker dat u wilt opslaan?</Label>
                    <br/>
                    <table>
                        <tr>
                            <td>
                                <DefaultButton autoFocus style={{margin:5, width:"100%"}} text="Niet opslaan" onClick={() => { setshowSaveConfirm(false); }} />
                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PrimaryButton style={{margin:5, width:"100%"}} text="Tags updaten" onClick={() => { saveInSite(); }} />
                            </td>
                            <td>
                                <Stack horizontal verticalAlign="center">
                                    <Label style={{marginLeft:5}}>Nieuwe sets worden toegevoegd en de setstructuur aangepast.</Label>
                                </Stack>        
                            </td>
                        </tr>
                    </table>
                </Stack>
            </Dialog>
            <Stack style={{margin:10, padding: 10, border: "1px solid blue"}}>
                <h2>Nieuwe Set</h2>
                <hr />
                <TextField label="Naam" value={NewSetName} onChange={(e,v) => { setNewSetName(v); }} />
                <Stack horizontal verticalAlign="end">
                    <ComboBox label="Parent set" options={SetsCBOptions} styles={{root:{width:"100%"}}} selectedKey={NewSetParentSet} onChange={(e,o,i,v) => { setNewSetParentSet(v);}} />
                    <PrimaryButton text="Wis" onClick={() => { setNewSetParentSet("");}} />
                </Stack>
                <Stack horizontal horizontalAlign="end" style={{marginTop:10, width:"100%"}}>
                    <img src={NewSetImgFile ? URL.createObjectURL(NewSetImgFile) : ""} style={{ width: "auto", height: "100px"}} />
                    <input id="upload" multiple type="file" hidden ref={newSetLogoInputRef} onChange={(e) => { setNewSetImgFile(e.target.files[0]); }} />
                    <PrimaryButton text="Set logo" onClick={() => { newSetLogoInputRef.current.click(); }} />
                </Stack>
                <hr />
                <Stack horizontal horizontalAlign="end" style={{marginTop:10}}>
                    <PrimaryButton disabled={!canAddSet()} text="Toevoegen in overzicht" onClick={() => { addSet(); }}/>
                    <PrimaryButton disabled={!canChangeSet()} text="Opslaan in site" onClick={() => {addSet(true);}} style={{marginLeft:10, backgroundColor:"red"}}/>
                </Stack>
            </Stack>
            <Stack style={{margin:10, padding: 10, border: "1px solid blue"}}>
                <Stack horizontal verticalAlign="center">
                    <h2>Sets</h2>
                    <div style={{width:"100%"}}></div>
                    <PrimaryButton disabled={ObjectArraysEqual(OrgSetTree, SetTree)} text="Opslaan in site" style={{width:"stretch", backgroundColor:"red"}} onClick={() => { saveInSite(); }} />
                </Stack>
                <hr />
                <ul>
                    {SetTree.map(tr => {
                        return <li key="tr.Value.name">
                                <Stack horizontal verticalAlign="center">
                                    <span style={{cursor:"pointer"}} onClick={() => {SetSelectedSet(tr); }}>{tr.Value.name}</span>
                                </Stack>
                                <ul>
                                    {tr.Children.map(c => {
                                        return <li key="c.Value.name">
                                                  <Stack horizontal verticalAlign="center">
                                                      <span style={{cursor:"pointer"}} onClick={() => {SetSelectedSet(c); }}>{c.Value.name}</span>
                                                  </Stack>
                                               </li>
                                    })}
                                </ul>
                               </li>
                    })}
                </ul>
            </Stack>
            {SelectedSet && <Stack style={{margin:10, padding: 10, border: "1px solid blue"}}>
                <h2>{SelectedSet.Value.name} aanpassen</h2>
                <hr />
                <TextField label="Naam" defaultValue={SelectedSet.Value.name} value={SelectedSetNewName ? SelectedSetNewName : SelectedSet.Value.name} onChange={(e,v) => { setSelectedSetNewName(v); }} />
                <Stack horizontal verticalAlign="end" style={{width:"100%"}}>
                    <ComboBox label="Parent set" options={SetsCBOptions} 
                              style={{width:"100%"}} 
                              selectedKey={SelectedSetNewParent !== undefined ? SelectedSetNewParent : SetTree.filter(st => st.Value.id === SelectedSet.Value.parentid).length ? SetTree.filter(st => st.Value.id === SelectedSet.Value.parentid)[0].Value.name : ""} 
                              onChange={(e,o,i,v) => { setSelectedSetNewParent(v);}} />
                    <PrimaryButton text="Wis" onClick={() => { setSelectedSetNewParent("");}} />
                </Stack>
                <Stack horizontal horizontalAlign="end" style={{marginTop:10}}>
                    <img src={SelectedSetNewImg ? URL.createObjectURL(SelectedSetNewImg) : 
                              SelectedSet.Logo ? URL.createObjectURL(SelectedSet.Logo) : `https://${props.site}.nl/assets/products/${SelectedSet.Value.id}/${SelectedSet.Value.id}.webp`} style={{ width: 200 }} />
                    <PrimaryButton text="Nieuw logo" style={{marginLeft:10, marginTop: 10, width:"100%"}} onClick={() => { logoInputRef.current.click(); }} />
                    <input id="upload" multiple type="file" hidden ref={logoInputRef} onChange={(e) => { setSelectedSetNewImg(e.target.files[0]); }} />
                </Stack>
                <Stack horizontal horizontalAlign="end" style={{marginTop:10}}>
                    <img src={SelectedSetBannerNewImg ? URL.createObjectURL(SelectedSetBannerNewImg) : 
                              SelectedSet.Banner ? URL.createObjectURL(SelectedSet.Banner) : `https://${props.site}.nl/assets/products/${SelectedSet.Value.id}/logo.webp`} style={{ width: 200 }} />
                    <Stack style={{overflow:"hidden"}}>
                        <PrimaryButton text="Nieuwe banner" style={{marginLeft:10, width:"100%"}} onClick={() => { bannerInputRef.current.click(); }} />
                        <Checkbox disabled={SelectedSetBannerNewImg || setBannerInCarousel ? false : true} styles={{root: {marginLeft:10, marginTop:10, width:"100%"}}} label="In carrousel" checked={bannerInCarousel} onChange={()=>{ setBannerInCarousel(!bannerInCarousel); }}/>
                        <input id="upload" multiple type="file" hidden ref={bannerInputRef} onChange={(e) => { setSelectedSetBannerNewImg(e.target.files[0]); }} />
                    </Stack>
                </Stack>
                <Stack horizontal horizontalAlign="end" style={{marginTop:10}}>
                    <PrimaryButton disabled={!canChangeSet()} text="Opslaan in overzicht" onClick={() => {updateSet();}}/>
                    <PrimaryButton disabled={!canChangeSet()} text="Opslaan in site" onClick={() => {updateSet(true);}} style={{marginLeft:10, backgroundColor:"red"}}/>
                </Stack>
                <hr />
                <EditTags set={SelectedSet.Value}
                          setMessage={props.setMessage} 
                          setError={props.setError}
                          token={props.token}
                          site={props.site}
                          username={props.username}
                          apiUrl={props.apiUrl} />
                <EditProps set={SelectedSet.Value}
                           setMessage={props.setMessage} 
                           setError={props.setError}
                           token={props.token}
                           site={props.site}
                           username={props.username}
                           apiUrl={props.apiUrl} />
                <hr />
            </Stack>}
        </Stack>
    );
}

export default SetManagerV2;